// extracted by mini-css-extract-plugin
export default {"root":"_1xiqT","heading-and-subheading-block":"_2n8xz","headingAndSubheadingBlock":"_2n8xz","subheading":"_8sMQZ"};